import { useTranslation } from 'react-i18next';
import { Modal, Props as ModalProps } from 'components/Modal';
import { Button } from 'components/Button';
import { Heading, Paragraph } from 'components/Typography';

type Props = ModalProps & {
  supportEmail: string;
};

export const CantFindTimeModal: React.FunctionComponent<Props> = ({ supportEmail, ...props }) => {
  const { t } = useTranslation();
  return (
    <Modal {...props}>
      <Heading level="h4" className="mb-16">
        {t('consultation.noTimeModal.title')}
      </Heading>

      <Paragraph className="mb-40 sm-d:mb-32">
        {t('schedule.appointmentNotFound.modalSubHeading', { supportEmail })}
      </Paragraph>

      <Button size="lg" className="sm-d:w-full" as="a" href={`mailto:${supportEmail}`}>
        {t('consultation.noTimeModal.button')}
      </Button>
    </Modal>
  );
};
